module.exports = __webpack_public_path__ + "static/img/jin2.e9c7ba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jin2.jpg
// module id = fP2Q
// module chunks = 1